import React from 'react'

import WidgetAjax from "../../widget/WidgetAjax"
import Config from '../../config/Config'
import Cache from "../../frame/Cache";
import "../../css/HomePage.css"

class MatterList extends React.Component 
{
    constructor(props)
    {
        super(props);

        this.state = {
            BasePath:Config.getBasePath(),
            userInfo:{},
            presentTime:{},
            taskSummary:{},
            systemTitle:'',
            mattersTabNum:0,
            businessMatters:[],
            loading:true
        }

        this.onloadTask = this.onloadTask.bind(this);
        this.onloadTaskDetail = this.onloadTaskDetail.bind(this);
        this.loadTime = this.loadTime.bind(this);
    }

    componentDidMount()
    {
        this.loadTask();
        this.loadTaskDetail(); 
        this.loadTime();
        this.loadUserInfo();
    }

    /**
     * 请求商机事项数量
     */
     loadTask()
     {
         let { BasePath } = this.state;
         let params = {
                "TASKSTATE" : "0"
         }

         WidgetAjax.ajax({url: BasePath + "/business/task_summary", params: undefined , callback:this.onloadTask});
         this.setState({ loading: true });
     }
 
     onloadTask( result )
     {
         if( result.status===0 )
         {
             this.setState({taskSummary:result.result,loading:false});
         }
         else if( result.status===10 ) 
         {
             Cache.logout(this.props);
         }
     }
 
     /**
      * 请求事项明细数据
      * @type {*} type 事项类型
      */
     loadTaskDetail(type = 0)
     {
         let { BasePath } = this.state;
 
         this.setState({mattersTabNum : type});
 
         WidgetAjax.ajax({url: BasePath + "/business/task", params: { "TASKSTATE": type } , callback: this.onloadTaskDetail});
         this.setState({loading:true})
     }
 
     onloadTaskDetail( result )
     {
         if( result.status===0 )
         {
             this.setState({ businessMatters:result.results,loading:false });
         }
         else if( result.status===10 ) 
         {
             Cache.logout(this.props);
         }
     }
 
    /**
     * 获取当前用户信息
     */
    loadUserInfo()
    {
        this.setState({
            userInfo:JSON.parse(sessionStorage.getItem("_user_info_")),
            systemTitle:Config.getSystemTitle()
        });
    }
     
    /**
     * 计算当前时间
     */
    loadTime()
    {
        let date = new Date();   
        let year = date.getFullYear();    
        let mon = date.getMonth()+1;      
        let day = date.getDate();
        let weekDay = date.getDay()

        switch(weekDay)
        {
            
            case 0:
                weekDay = "日";
                break;
            case 1:
                weekDay = "一";
                break;
            case 2:
                weekDay = "二";
                break;
            case 3:
                weekDay = "三";
                break;
            case 4:
                weekDay = "四";
                break;
            case 5:
                weekDay = "五";
                break;
            case 6:
                weekDay = "六";
                break;
            default:
                break;
        }

        let timeObj = {
            today:`${year}.${mon<10?"0"+mon:mon}.${day<10?"0"+day:day}`,
            week:`星期${weekDay}`
        }

        this.setState({
            presentTime:timeObj
        });
    }


    render() 
    {
        let { userInfo, presentTime, taskSummary, systemTitle, mattersTabNum, businessMatters,loading } = this.state;
        return (
            
            <div className="personalMatters background-fff marginbottom-16 overflow-hidden radius-5 border-1 box-shadow">
                <div className="personalTitle height-96 color-ffffff">
                    <div className="personalTitleTop">
                        <p className="userName font-24 floatleft clear-margin font-PingFangFC">{userInfo.realname}</p>
                        <p className="week clear-margin font-16 font-PingFangFC">{presentTime.week}</p>
                    </div>  
                    <div className="personalTitleBottom paddingtop-8">
                        <span className="floatleft clear-margin paddingleft-20px font-16 fontfamily-song font-PingFangFC">{`欢迎登陆${systemTitle}`}</span>
                        <p className="floatright paddingright-20 font-16 font-PingFangFC">{presentTime.today}</p>
                    </div>
                </div>
                <div className="mattersTabs">
                    <div className="personalBodytabsTitle cursor-pointer">
                        <div onClick={()=>{this.loadTaskDetail(0)}}
                                className={ mattersTabNum===0 ? 
                                            "width-50 height-94 paddingtop-10 floatleft textalign-center active" : 
                                            "width-50 height-94 paddingtop-10 floatleft textalign-center backgroundColor-FAFCFF"
                                }
                        >
                            <p className="font-30 color-EE6364 clear-margin font-PingFangFC">{taskSummary.TODO}</p>
                            <span className="font-16 font-PingFangFC color-646464 ">{"待办事项"}</span>
                        </div>
                        <div onClick={()=>{this.loadTaskDetail(1)}}
                                className={ mattersTabNum===1 ? 
                                            "width-50 height-94 paddingtop-10 floatleft textalign-center active" : 
                                            "width-50 height-94 paddingtop-10 floatleft textalign-center backgroundColor-FAFCFF"
                                }
                        >
                            <p className="font-30 color-3AAD6E clear-margin font-PingFangFC">{taskSummary.COMPLETED}</p>
                            <span className="font-16 font-PingFangFC color-646464">{"已办事项"}</span>
                        </div>
                    </div>
                    <div className="mattersListCotent listFather flex-1">
                        <ul className="listchildren liststyle-none clear-padding clear-margin  overflow-auto  background" >
                        {loading?<img src={require('../../img/frame/loading.gif')} className="loading-matterList" alt="es-lint want to get"/>:
                            <>{   businessMatters===undefined || businessMatters===null || businessMatters.length===0 ?
                                <p style={{width:"100%",textAlign:"center",paddingTop:"65px"}}><img src={require('../../css/widget/img/no-data.svg')}></img></p> :
                                businessMatters.map((val, index)=>{
                                    return (
                                        <li className="matters-list display-flex hover-016EFF" key={index}>
                                            <span className="flex-2 color-323232 display-flex font-14 font-PingFangFC alignitem-center">{val. TASKNAME}</span>
                                            <span className="flex-2 color-323232 display-flex font-14 font-PingFangFC  alignitem-center">{val.REALNAME}</span>
                                            <span className="flex-1 color-323232 display-flex font-14 font-PingFangFC textalign-right alignitem-center">{val.TASKDATE}</span>
                                        </li>
                                    )
                                })
                            }</>
                        }
                        </ul>
                    </div>
                </div>
            </div> 
        )
    }
}

export default MatterList